export const camelCaseToRegularForm = (text: string) => {
  return text.replace(/([A-Z])/g, ' $1').trim();
};
